// extracted by mini-css-extract-plugin
export default {"wrap":"style_wrap__733kv","desktopOnly":"style_desktopOnly__IF6ah","background":"style_background__xsquD","children_wrap":"style_children_wrap__6n860"};